import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 96.2 19.1"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode(".st0{fill-rule:evenodd;clip-rule:evenodd}")
      ])),
      _: 1
    })),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "M43.6 5.2c-.2-.8-.5-1.7-2.4-1.7S39 4.2 39 4.8c0 2.1 8.5.6 8.5 5.5 0 3.9-3.8 4.6-5.9 4.6-3.1 0-6.4-1-6.5-4.6h3.7c0 1.1.7 1.9 2.9 1.9 1.8 0 2.3-.9 2.3-1.4 0-2.2-8.4-.5-8.4-5.5 0-1.9 1.2-4.4 5.5-4.4 2.6 0 5.8.6 6.1 4.4h-3.6zM67.4 14.4h-3.6v-8c0-2-.9-2.6-1.9-2.6-1.8 0-2.4 1.1-2.4 2.7v7.9H56v-8c0-1.1 0-2.7-2.1-2.7-1.7 0-2.2 1.1-2.2 2.6v8.1h-3.6V1.2h3.4v1.9h.1C52 2.3 53 .8 55.4.8c2 0 2.8.7 3.8 2.1.5-.6 1.4-2.1 3.6-2.1 2.6 0 4.7 1.5 4.7 4.4v9.2zM81.3 10.6c-.9 3.2-3.6 4.2-5.9 4.2-3.8 0-6.7-1.8-6.7-7.2 0-1.6.6-6.7 6.5-6.7 2.7 0 6.4 1.2 6.4 7.3v.6h-9.3c.1 1 .3 3.2 3.2 3.2 1 0 2-.5 2.3-1.4zm-3.5-4.1c-.2-2.1-1.6-2.8-2.7-2.8-1.7 0-2.6 1-2.8 2.8zM95.8.8v12.1c0 2.2-.2 5.9-6.8 5.9-2.8 0-5.7-1.1-5.9-3.8H87c.2.6.4 1.3 2.5 1.3 1.9 0 2.8-.9 2.8-2.9v-1.5h-.1c-.6 1-1.5 1.9-3.6 1.9-3.3 0-5.8-2.1-5.8-6.6 0-4.4 2.6-6.6 5.6-6.6 2.5 0 3.5 1.4 4 2.2h.1v-2zm-6.6 9.9c2.4 0 3-1.9 3-3.7 0-2.1-1.1-3.7-3-3.7-1.3 0-2.8.9-2.8 3.9 0 1.6.7 3.5 2.8 3.5M9.1 14.4c0 2.4-1.9 4.3-4.3 4.3S.5 16.8.5 14.4C.4 12 2.4 10 4.8 10c2.3 0 4.3 2 4.3 4.4",
      class: "st0"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M17.7 14.4c0 2.4-1.9 4.3-4.3 4.3s-4.3-1.9-4.3-4.3S11 10 13.4 10s4.3 2 4.3 4.4M26.4 14.4c0 2.4-1.9 4.3-4.3 4.3s-4.3-1.9-4.3-4.3 1.9-4.3 4.3-4.3c2.4-.1 4.3 1.9 4.3 4.3M17.7 5.7c0 2.4-1.9 4.3-4.3 4.3S9.1 8.1 9.1 5.7s1.9-4.3 4.3-4.3 4.3 1.9 4.3 4.3M26.4 5.7c0 2.4-1.9 4.3-4.3 4.3s-4.3-1.9-4.3-4.3 1.9-4.3 4.3-4.3 4.3 1.9 4.3 4.3M35.1 5.7c0 2.4-1.9 4.3-4.3 4.3s-4.3-1.9-4.3-4.3 1.9-4.3 4.3-4.3c2.3 0 4.3 1.9 4.3 4.3",
      class: "st0"
    }, null, -1))
  ]))
}
export default { render: render }